import { Theme } from "./theme.model";

export class Portal {
    constructor(json?: any) {
        this.id = json && json.id || null;
        this.portalName = json && json.portal_name || "";
        this.teamRNID = json && json.team_rnid || null;
        this.leagueRNID = json && json.league_rnid || null;
        this.themeID = json && json.theme_id || null;
        this.logo = json && json.logo || null;
        this.banner = json && json.banner || null;
        this.ownerID = json && json.owner_id || null;
        this.chatServiceID = json && json.chat_service_id || null;
        this.allowUserCommunication = json && json.allow_user_communication || null;
        this.isSecure = json && json.is_secure || false;
        this.isStandard = json && json.is_standard || false;
        this.subscriptionCount = json && json.subscription_count || null;
        this.allowFileManagement = json && json.allow_file_management || false;
        this.parentPortalID = json && json.parent_portal_id || null;
        this.parentPortalName = json && json.parent_portal_name || null;
        this.subscriptionExpiration = json && json.subscription_expiration || null;
        this.disableChat = json && json.disable_chat || false;
        this.isGlobalChannel = json && json.is_global_channel || false;
        this.isGlobal = (json && json.is_global != null) ? json.is_global : false;
        this.allowGlobalPosts = (json && json.allow_global_posts != null) ? json.allow_global_posts : false;
        this.isPortalMember = (json && json.is_portal_member != null) ? json.is_portal_member : null;
        this.portalSelected = false;
        this.theme = new Theme();
    }

    id: number;
    portalName: string;
    teamRNID: number;
    leagueRNID: number;
    themeID: number;
    logo: string;
    banner: string;
    ownerID: number;
    chatServiceID: number;
    allowUserCommunication: boolean;
    isSecure: boolean;
    isStandard: boolean;
    subscriptionCount: number;
    allowFileManagement: boolean;
    parentPortalID: number;
    parentPortalName: number;
    subscriptionExpiration: string;
    disableChat: boolean;
    isGlobalChannel: boolean;
    isGlobal: boolean;
    allowGlobalPosts: boolean;
    isPortalMember: boolean;
    portalSelected: boolean;
    theme: Theme;

    populate(portal: Portal) {
        this.id = portal.id;
        this.portalName = portal.portalName;
        this.teamRNID = portal.teamRNID;
        this.leagueRNID = portal.leagueRNID;
        this.themeID = portal.themeID;
        this.logo = portal.logo;
        this.banner = portal.banner;
        this.ownerID = portal.ownerID;
        this.chatServiceID = portal.chatServiceID;
        this.allowUserCommunication = portal.allowUserCommunication;
        this.isSecure = portal.isSecure;
        this.isStandard = portal.isStandard;
        this.subscriptionCount = portal.subscriptionCount;
        this.allowFileManagement = portal.allowFileManagement;
        this.parentPortalID = portal.parentPortalID;
        this.subscriptionExpiration = portal.subscriptionExpiration;
        this.disableChat = portal.disableChat;

        this.portalSelected = portal.portalSelected;
        this.theme = portal.theme;
    }
}
